module.exports = __webpack_public_path__ + "static/lifestyle2-30281159ff8bc36a317aa153801df31b.jpg";